import { TranslateLoader, Translation, TranslationObject } from "@ngx-translate/core";
import { forkJoin, map, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

export class CustomTranslateHttpLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly urls: string[],
    private readonly suffix = ".json"
  ) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    const requests: readonly Observable<object>[] = this.urls.map((u: string) =>
      this.http.get<object>(`${u}${lang}${this.suffix}`)
    );
    return forkJoin(requests).pipe(
      map<object[], TranslationObject>((translations) => this.#combineJsons(translations))
    );
  }

  #combineJsons(jsons: object[]): Translation {
    const combined = {};
    jsons.forEach((json) => Object.assign(combined, json));
    this.#checkIfCorrectlyMerged(combined, jsons);
    return combined;
  }

  #checkIfCorrectlyMerged(combined: object, jsons: object[]) {
    jsons.forEach((json) => {
      const keys = Object.keys(json);
      keys.forEach((k) => {
        if (!Object.prototype.hasOwnProperty.call(combined, k)) {
          console.error(new Error(`${k} field was not properly merged in translations`));
        }
      });
    });
  }
}
